import queryString from 'query-string';
import { get } from 'lodash';
import axios, { baseUrl } from './axios';

export default {
  sendVerifyCode: async options => {
    const params = queryString.stringify(options.data);
    const result = await axios.get(
      `${baseUrl}/account/pob/patient/verify_codes${
        params ? `?${params}` : ''
      }`,
    );
    return result.data;
  },
  confirmVerifyCode: async options => {
    const result = await axios.post(
      `${baseUrl}/account/pob/patient/verify_codes`,
      options.data,
    );
    return result.data;
  },
  createPatientAccount: async options => {
    const result = await axios.post(
      `${baseUrl}/account/pob/patients/${options.patientId}/accounts`,
      options.data,
    );

    return result.data;
  },
  createPatientInfo: async options => {
    // const token = get(options, 'token');
    // let transformRequest = {};
    // if (token) {
    //   transformRequest = {
    //     transformRequest: [
    //       (data, headers) => {
    //         headers.common.Authorization = `Bearer ${options.token}`;
    //         return JSON.stringify(data);
    //       },
    //     ],
    //   };
    // }
    const result = await axios.post(
      `${baseUrl}/customer/pob/patients`,
      // transformRequest,
      options.data,
    );

    return result.data;
  },
  getListPatientKin: async options => {
    const token = get(options, 'token');
    let transformRequest = {};
    if (token) {
      transformRequest = {
        transformRequest: [
          (data, headers) => {
            headers.common.Authorization = `Bearer ${options.token}`;
            return JSON.stringify(data);
          },
        ],
      };
    }
    const result = await axios.get(
      `${baseUrl}/customer/pob/patient/${options.patientId}/next_of_kins`,
      transformRequest,
    );

    return result.data;
  },
};
